import { Component, computed, ElementRef, inject, Signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionsStepComponent } from './steps/subscriptions-step/subscriptions-step.component';
import { PaymentStepComponent } from './steps/payment-step/payment-step.component';
import { SignupV2Service } from './signup-v2.service';
import { SignalsStoreService } from '../../shared/signals-store.service';
import { DeliveryAddressStepComponent } from './steps/delivery-address-step/delivery-address-step.component';
import { FaqsComponent } from '../signup/faqs/faqs.component';
import { FooterComponent } from '../../shared/footer/footer.component';
import { AvailabilityStepComponent } from './steps/availability-step/availability-step.component';
import { ProduceBoxStepComponent } from './steps/produce-box-step/produce-box-step.component';
import { PersonalInfoStepComponent } from './steps/personal-info-step/personal-info-step.component';
import { RouterLink } from '@angular/router';
import { SignupFlowStep } from './signup-v2.service';

@Component({
  selector: 'app-signup-v2',
  standalone: true,
  imports: [CommonModule,
    DeliveryAddressStepComponent,
    AvailabilityStepComponent,
    ProduceBoxStepComponent,
    SubscriptionsStepComponent,
    PersonalInfoStepComponent,
    PaymentStepComponent,
    FaqsComponent,
    FooterComponent,
    RouterLink
  ],
  templateUrl: './signup-v2.component.html',
  styleUrl: './signup-v2.component.scss'
})
export class SignupV2Component {
  @ViewChild('scrollToTopRef') scrollToTopRef!: ElementRef;
  private signalsStoreService = inject(SignalsStoreService);

  logoVersionNumber = computed(() => this.signalsStoreService.logoVersionNumber());

  howItWorks = [
    {
      image: '/assets/images/signup-v2/how-it-works/step-1.svg',
      alt: 'We Find What’s Fresh',
      number: 1,
      title1: 'We Find',
      title2: 'What’s Fresh',
      text: 'Each week, we check in with our farmers, growers and producers, then update our market and farm shares with the latest, freshest offerings.'
    },
    {
      image: '/assets/images/signup-v2/how-it-works/step-3.svg',
      alt: 'You Start Filling Your Basket',
      number: 2,
      title1: 'You Start',
      title2: 'Filling Your Basket',
      text: 'You can start shopping when the market opens each Friday and make any changes to your farmshares and subscriptions. Then you can make any edits to your order until 7 a.m. the day before delivery. '
    },
    {
      image: '/assets/images/signup-v2/how-it-works/step-4.svg',
      alt: 'We Pick and Pack',
      number: 3,
      title1: 'We Pick',
      title2: 'and Pack',
      text: 'Once your order’s locked in, our growers get busy picking, gathering, and harvesting. Then we bring your food from their farms to our Hunting Park warehouse, where we pack your box'
    },
    {
      image: '/assets/images/signup-v2/how-it-works/step-2.svg',
      alt: 'Fresh Delivery',
      number: 4,
      title1: 'Fresh',
      title2: 'Delivery',
      text: 'Once your box is packed, it’s on the road to your door. And because it was harvested within 72 of arriving, your produce shows up crisp, fresh, and full of flavor.'
    }
  ]

  constructor(public svc: SignupV2Service) { }
  get steps() {
    const allSteps = this.svc.steps;
    // Filter out payment step if no products are selected
    if (!this.svc.hasSelectedProducts() && !this.svc.getIsAbandonedFlow()) {
      return allSteps.filter(step => step.key !== 'payment');
    }
    return allSteps;
  }
  get currentIndex(): number { return this.svc.getCurrentStepIndex(); }
  get currentStep() { return this.steps[this.currentIndex]; }

  goTo(index: number) { this.svc.goToIfAllowed(index); }

  onStepCompleted() {
    // Avanzar al siguiente paso cuando un step se completa
    if (this.currentIndex < this.steps.length - 1) {
      const nextIndex = this.currentIndex + 1;
      this.svc.setCurrentStepIndex(nextIndex);
      this.scrollToTopRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
